(function(){
  'use strict';
  const $=(s,c=document)=>c.querySelector(s);
  const $$=(s,c=document)=>Array.from(c.querySelectorAll(s));
  const money=c=>{
    const f=(window.TGP&&TGP.moneyFormat)||'{{amount}} kr';
    const v=(c/100).toLocaleString('sv-SE',{minimumFractionDigits:0,maximumFractionDigits:0});
    return f.replace(/\{\{\s*amount[^}]*\}\}/,v);
  };

  /* ---------- Drawer + overlay ---------- */
  const overlay=$('#overlay'), drawer=$('#cart-drawer'), mnav=$('#mnav');
  function lock(b){document.documentElement.style.overflow=b?'hidden':''}
  function openDrawer(){drawer&&drawer.classList.add('open');overlay&&overlay.classList.add('open');lock(true)}
  function closeAll(){drawer&&drawer.classList.remove('open');mnav&&mnav.classList.remove('open');overlay&&overlay.classList.remove('open');lock(false);$('#pop')&&$('#pop').classList.remove('open')}
  overlay&&overlay.addEventListener('click',closeAll);
  $$('[data-cart-open]').forEach(b=>b.addEventListener('click',e=>{e.preventDefault();openDrawer()}));
  $$('[data-close]').forEach(b=>b.addEventListener('click',closeAll));
  document.addEventListener('keydown',e=>{if(e.key==='Escape')closeAll()});

  /* ---------- Mobile nav ---------- */
  $('[data-menu-open]')&&$('[data-menu-open]').addEventListener('click',()=>{mnav.classList.add('open');overlay.classList.add('open');lock(true)});

  /* ---------- Cart: render + AJAX ---------- */
  function renderCart(cart){
    const wrap=$('#cart-items'), foot=$('#cart-foot'), empty=$('#cart-empty');
    $$('[data-cart-count]').forEach(el=>{el.textContent=cart.item_count;el.hidden=cart.item_count===0});
    if(!wrap)return;
    if(cart.item_count===0){wrap.innerHTML='';foot&&(foot.hidden=true);empty&&(empty.hidden=false);return}
    empty&&(empty.hidden=true);foot&&(foot.hidden=false);
    wrap.innerHTML=cart.items.map(it=>`
      <div class="line" data-key="${it.key}">
        <a class="line__img" href="${it.url}"><img src="${it.image?it.image.replace(/(\.[a-z]+)(\?|$)/i,'_240x240$1$2'):''}" alt="${it.product_title}" loading="lazy"></a>
        <div>
          <a class="line__t" href="${it.url}">${it.product_title}</a>
          ${it.variant_title&&it.variant_title!=='Default Title'?`<div class="line__v">${it.variant_title}</div>`:''}
          <div class="qty">
            <button data-dec aria-label="Decrease">–</button>
            <input value="${it.quantity}" data-qty inputmode="numeric" aria-label="Quantity">
            <button data-inc aria-label="Increase">+</button>
          </div>
        </div>
        <div class="line__price">${money(it.final_line_price)}</div>
      </div>`).join('');
    $('#cart-subtotal')&&($('#cart-subtotal').textContent=money(cart.total_price));
    updateShip(cart.total_price);
    bindLines();
  }
  function updateShip(total){
    const bar=$('#ship-bar'); if(!bar)return;
    const goal=(window.TGP&&TGP.freeShip)||0; if(!goal){bar.hidden=true;return}
    const left=goal-total, fill=$('#ship-fill'), txt=$('#ship-txt');
    if(left<=0){txt.innerHTML="You've unlocked free shipping &#x2715;"}
    else{txt.textContent=`${money(left)} to free shipping`}
    fill&&(fill.style.width=Math.min(100,total/goal*100)+'%');
  }
  function bindLines(){
    $$('.line').forEach(line=>{
      const key=line.dataset.key, input=$('[data-qty]',line);
      const set=q=>change(key,Math.max(0,q));
      $('[data-inc]',line).onclick=()=>set(parseInt(input.value)+1);
      $('[data-dec]',line).onclick=()=>set(parseInt(input.value)-1);
      const rm=$('[data-rm]',line); rm&&(rm.onclick=()=>set(0));
      input.onchange=()=>set(parseInt(input.value)||0);
    });
  }
  /* Terms checkbox gates checkout */
  (function(){
    const cb=$('#cart-terms'), go=$('#cart-checkout');
    if(!cb||!go)return;
    const sync=()=>{go.classList.toggle('is-disabled',!cb.checked);go.setAttribute('aria-disabled',String(!cb.checked))};
    cb.addEventListener('change',sync);sync();
    go.addEventListener('click',e=>{if(!cb.checked){e.preventDefault();cb.focus();cb.closest('.drawer__terms').classList.add('shake');setTimeout(()=>cb.closest('.drawer__terms').classList.remove('shake'),500)}});
  })();
  function change(key,qty){
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
      .then(r=>r.json()).then(renderCart);
  }
  window.TGPaddToCart=function(form,btn){
    const fd=new FormData(form);
    btn&&(btn.disabled=true,btn.dataset.txt=btn.textContent,btn.textContent='Adding…');
    fetch('/cart/add.js',{method:'POST',body:fd})
      .then(r=>r.json()).then(()=>fetch('/cart.js').then(r=>r.json()))
      .then(cart=>{renderCart(cart);openDrawer()})
      .catch(()=>{form.submit()})
      .finally(()=>{if(btn){btn.disabled=false;btn.textContent=btn.dataset.txt||'Add to cart'}});
  };
  // initial counts
  fetch('/cart.js').then(r=>r.json()).then(c=>{$$('[data-cart-count]').forEach(el=>{el.textContent=c.item_count;el.hidden=c.item_count===0});updateShip(c.total_price);if($('#cart-items'))renderCart(c)}).catch(()=>{});

  /* ---------- PDP gallery (thumbs + arrows) ---------- */
  function bindGallery(g){
    const wrap=$('[data-gallery-main]',g); const main=wrap&&$('img',wrap); const thumbs=$$('[data-thumb]',g);
    if(!main||!thumbs.length)return;
    let i=Math.max(0,thumbs.findIndex(t=>t.classList.contains('active')));
    function show(n){i=(n+thumbs.length)%thumbs.length;const t=thumbs[i];main.removeAttribute('srcset');main.src=t.dataset.full;if(t.dataset.ratio)wrap.style.setProperty('--ratio',t.dataset.ratio);thumbs.forEach((x,k)=>x.classList.toggle('active',k===i));}
    thumbs.forEach((t,k)=>t.addEventListener('click',()=>show(k)));
    $$('[data-gnav]',g).forEach(b=>b.addEventListener('click',()=>show(i+(b.dataset.gnav==='next'?1:-1))));
  }
  $$('[data-gallery]').forEach(bindGallery);

  /* ---------- Variant selection (rebindable + click-safe) ---------- */
  function bindForm(form){
    if(form.__bound)return; form.__bound=true;
    const data=window.__variants&&window.__variants[form.dataset.productForm];
    const swatches=$$('.swatch',form), priceEl=$(`[data-price="${form.dataset.productForm}"]`);
    const idInput=$('[name="id"]',form), btn=$('[data-atc]',form);
    function selected(){const o={};$$('.opt',form).forEach(opt=>{const c=$('input:checked',opt);if(c)o[opt.dataset.idx]=c.value});return o}
    function match(){if(!data)return null;const s=selected();return data.find(v=>v.options.every((ov,i)=>ov===s[i]))}
    function refresh(){
      swatches.forEach(sw=>{const inp=$('input',sw);if(inp)sw.classList.toggle('checked',inp.checked)});
      const v=match();
      if(v){if(idInput)idInput.value=v.id;
        if(priceEl)priceEl.innerHTML=v.compare>v.price?`<span class="price--now on-sale">${money(v.price)}</span><span class="price--was">${money(v.compare)}</span>`:money(v.price);
        if(btn){btn.disabled=!v.available;btn.textContent=v.available?((window.TGP&&TGP.atc)||'Add to cart'):'Sold out'}
        const sb=$('#sticky-price');sb&&(sb.textContent=money(v.price));
      }
    }
    swatches.forEach(sw=>{const inp=$('input',sw);if(!inp)return;
      inp.addEventListener('change',refresh);
      sw.addEventListener('click',e=>{if(e.target!==inp){inp.checked=true;}refresh();});
    });
    refresh();
    form.addEventListener('submit',e=>{e.preventDefault();window.TGPaddToCart(form,btn)});
  }
  $$('[data-product-form]').forEach(bindForm);

  /* rebind gallery + product form when a section is re-rendered in the editor */
  document.addEventListener('shopify:section:load',e=>{
    $$('[data-gallery]',e.target).forEach(bindGallery);
    $$('[data-product-form]',e.target).forEach(bindForm);
  });

  /* ---------- Accordion ---------- */
  $$('.acc__h').forEach(h=>h.addEventListener('click',()=>{
    const a=h.closest('.acc'),c=$('.acc__c',a),open=a.classList.toggle('open');
    c.style.maxHeight=open?c.scrollHeight+'px':0;
  }));

  /* ---------- Sticky mobile buy ---------- */
  const sticky=$('#sticky-buy'),buybox=$('.buybox');
  if(sticky&&buybox){const io=new IntersectionObserver(([e])=>sticky.classList.toggle('show',!e.isIntersecting),{rootMargin:'-200px 0px 0px'});io.observe(buybox);
    $('[data-sticky-atc]')&&$('[data-sticky-atc]').addEventListener('click',()=>{const f=$('[data-product-form]');f&&window.TGPaddToCart(f,$('[data-atc]',f))});}

  /* ---------- Header hide on scroll ---------- */
  let last=0;const hdr=$('.site-header');
  addEventListener('scroll',()=>{const y=scrollY;if(hdr){hdr.style.transform=(y>last&&y>320)?'translateY(-100%)':'none'}last=y},{passive:true});

  /* ---------- Reveal on scroll (robust: editor re-render + no-JS) ---------- */
  const design=window.Shopify&&Shopify.designMode;
  const reveal=el=>el.classList.add('in');
  let ro=null;
  if('IntersectionObserver' in window && !design){
    ro=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){reveal(e.target);ro.unobserve(e.target)}}),{rootMargin:'0px 0px -8% 0px'});
    $$('.reveal').forEach(el=>ro.observe(el));
  }else{
    $$('.reveal').forEach(reveal);
  }
  document.addEventListener('shopify:section:load',e=>$$('.reveal',e.target).forEach(el=>ro?ro.observe(el):reveal(el)));
  document.addEventListener('shopify:section:select',e=>$$('.reveal',e.target).forEach(reveal));

  /* ---------- Scramble headline ---------- */
  $$('[data-scramble]').forEach(el=>{
    const chars='ABCDEFGHIJKLMNOPQRSTUVWXYZ#/⊕*',target=el.textContent;let frame=0;
    const io=new IntersectionObserver(([e])=>{if(!e.isIntersecting)return;io.disconnect();
      const id=setInterval(()=>{el.textContent=target.split('').map((c,i)=>i<frame?c:(c===' '?' ':chars[Math.floor(Math.random()*chars.length)])).join('');frame+=1/2;if(frame>=target.length){clearInterval(id);el.textContent=target}},28);
    });io.observe(el);
  });

  /* ---------- Newsletter popup ---------- */
  const pop=$('#pop');
  if(pop){
    const closePop=()=>{pop.classList.remove('open');overlay&&overlay.classList.remove('open');localStorage.setItem('tgp_pop','1')};
    $$('[data-pop-close]',pop).forEach(b=>b.addEventListener('click',closePop));
    /* Copy discount code */
    const copyBtn=$('[data-copy-code]',pop);
    if(copyBtn){
      copyBtn.addEventListener('click',()=>{
        const c=$('[data-code]',pop);if(!c)return;
        const txt=c.textContent.trim();
        if(navigator.clipboard&&navigator.clipboard.writeText){navigator.clipboard.writeText(txt)}
        else{const ta=document.createElement('textarea');ta.value=txt;document.body.appendChild(ta);ta.select();document.execCommand('copy');ta.remove()}
        copyBtn.textContent='Copied ✓';setTimeout(()=>{copyBtn.textContent='Copy code'},1800);
      });
    }
    const posted=/[?&]customer_posted=true/.test(location.search);
    const hasErrors=!!$('.pop__err',pop);
    if((posted&&$('[data-pop-success]',pop))||hasErrors){
      /* Reopen after signup to reveal the code (or show errors) */
      pop.classList.add('open');overlay&&overlay.classList.add('open');
      if(posted){localStorage.setItem('tgp_pop','1');history.replaceState&&history.replaceState(null,'',location.pathname)}
    }else if(!localStorage.getItem('tgp_pop')&&document.body.classList.contains('tpl-index')){
      setTimeout(()=>{pop.classList.add('open');overlay&&overlay.classList.add('open')},(window.TGP.popDelay||7000));
    }
  }

  /* ---------- Drop countdown ---------- */
  $$('[data-countdown]').forEach(function(el){
    var target=new Date(el.getAttribute('data-countdown')).getTime();
    if(isNaN(target))return;
    var d=$('[data-d]',el),h=$('[data-h]',el),m=$('[data-m]',el),s2=$('[data-s]',el);
    var pad=function(n){return String(n).padStart(2,'0')};
    var t;
    function tick(){
      var diff=target-Date.now();
      if(diff<=0){el.innerHTML='<span class="hero__drop-label">THE DROP IS LIVE</span>';clearInterval(t);return;}
      d&&(d.textContent=pad(Math.floor(diff/864e5)));
      h&&(h.textContent=pad(Math.floor(diff%864e5/36e5)));
      m&&(m.textContent=pad(Math.floor(diff%36e5/6e4)));
      s2&&(s2.textContent=pad(Math.floor(diff%6e4/1e3)));
    }
    tick();t=setInterval(tick,1000);
  });

})();

/* ============================================================
   PDP v2 — media slider, size availability, drop gate, USP, share
   ============================================================ */
(function(){
  'use strict';
  var $=function(s,c){return (c||document).querySelector(s)};
  var $$=function(s,c){return Array.prototype.slice.call((c||document).querySelectorAll(s))};

  function initPdp(root){
    if(!root||root.__pdp)return; root.__pdp=true;

    var form=$('[data-product-form]',root);
    var grid=$('[data-media-grid]',root);
    var cells=grid?$$('.pdp-cell',grid):[];
    var dots=$$('[data-dot]',root);
    var isSlider=function(){return window.matchMedia('(max-width:900px)').matches};

    /* ---- media slider dots ---- */
    if(grid&&dots.length){
      var setDot=function(i){dots.forEach(function(d,k){d.classList.toggle('on',k===i)})};
      dots.forEach(function(d,k){
        d.addEventListener('click',function(){
          var c=cells[k]; if(!c)return;
          grid.scrollTo({left:c.offsetLeft-grid.offsetLeft,behavior:'smooth'});
          setDot(k);
        });
      });
      var raf;
      grid.addEventListener('scroll',function(){
        cancelAnimationFrame(raf);
        raf=requestAnimationFrame(function(){
          var i=Math.round(grid.scrollLeft/Math.max(1,grid.clientWidth));
          setDot(Math.max(0,Math.min(dots.length-1,i)));
        });
      },{passive:true});
    }

    /* ---- variant availability + colour label ---- */
    function variants(){
      return (form&&window.__variants&&window.__variants[form.dataset.productForm])||null;
    }
    function refreshOptions(){
      var data=variants(); if(!data)return;
      var opts=$$('.opt',root);
      var sel={};
      opts.forEach(function(o){var c=$('input:checked',o); if(c)sel[o.dataset.idx]=c.value});

      opts.forEach(function(o){
        var idx=parseInt(o.dataset.idx,10);
        $$('.swatch',o).forEach(function(sw){
          var val=sw.getAttribute('data-value'); if(val===null)return;
          var ok=data.some(function(v){
            if(!v.available)return false;
            if(v.options[idx]!==val)return false;
            for(var k in sel){ if(parseInt(k,10)===idx)continue; if(v.options[parseInt(k,10)]!==sel[k])return false }
            return true;
          });
          sw.classList.toggle('soldout',!ok);
        });
        var lbl=$('[data-selected-for]',o), chk=$('input:checked',o);
        if(lbl&&chk)lbl.textContent=chk.value;
      });

      /* jump to the matching image when a colourway changes */
      var match=data.filter(function(v){
        for(var k in sel){ if(v.options[parseInt(k,10)]!==sel[k])return false }
        return true;
      })[0];
      if(match&&match.media&&grid){
        var cell=$('[data-media-id="'+match.media+'"]',grid);
        if(cell&&isSlider()){
          grid.scrollTo({left:cell.offsetLeft-grid.offsetLeft,behavior:'smooth'});
        }
      }
    }
    if(form){
      form.addEventListener('change',function(){setTimeout(refreshOptions,0)});
      form.addEventListener('click',function(e){ if(e.target.closest('.swatch'))setTimeout(refreshOptions,0) });
      refreshOptions();
    }

    /* ---- drop gate ---- */
    $$('[data-drop-gate][data-drop-at]',root).forEach(function(gate){
      var at=parseInt(gate.getAttribute('data-drop-at'),10)*1000;
      if(isNaN(at))return;
      var atc=$('[data-atc]',gate);
      var soon=$('[data-drop-btn]',gate);
      if(!soon&&atc){
        soon=document.createElement('span');
        soon.className='btn btn--block btn--lg btn--soon';
        soon.setAttribute('data-drop-btn','');
        soon.textContent=gate.getAttribute('data-drop-label')||'Coming soon';
        soon.hidden=true;
        gate.insertBefore(soon,atc);
      }
      if(!atc||!soon)return;
      var t=setInterval(sync,1000);
      function sync(){
        var live=Date.now()>=at;
        soon.hidden=live;
        atc.hidden=!live;
        if(live)clearInterval(t);
      }
      sync();
    });

    /* ---- USP rotator ---- */
    var usp=$('[data-usp]',root);
    if(usp){
      var slides=$$('.usp__slide',usp), udots=$$('[data-usp-dot]',usp), ui=0, timer;
      if(slides.length>1){
        var go=function(n){
          ui=(n+slides.length)%slides.length;
          slides.forEach(function(s,k){s.classList.toggle('on',k===ui)});
          udots.forEach(function(d,k){d.classList.toggle('on',k===ui)});
        };
        var start=function(){timer=setInterval(function(){go(ui+1)},4200)};
        var stop=function(){clearInterval(timer)};
        udots.forEach(function(d,k){d.addEventListener('click',function(){stop();go(k);start()})});
        usp.addEventListener('mouseenter',stop);
        usp.addEventListener('mouseleave',start);
        start();
      }
    }

    /* ---- share ---- */
    var share=$('[data-share]',root);
    if(share){
      share.addEventListener('click',function(){
        var url=share.getAttribute('data-url')||location.href;
        var title=(document.querySelector('.pdp-title')||{}).textContent||document.title;
        if(navigator.share){navigator.share({title:title.trim(),url:url}).catch(function(){});return}
        var done=function(){
          share.classList.add('is-copied');
          var old=share.getAttribute('aria-label');
          share.setAttribute('aria-label','Link copied');
          setTimeout(function(){share.classList.remove('is-copied');share.setAttribute('aria-label',old||'Share')},1600);
        };
        if(navigator.clipboard&&navigator.clipboard.writeText){navigator.clipboard.writeText(url).then(done).catch(function(){})}
        else{var ta=document.createElement('textarea');ta.value=url;document.body.appendChild(ta);ta.select();try{document.execCommand('copy')}catch(e){}ta.remove();done()}
      });
    }
  }

  $$('[data-pdp]').forEach(initPdp);
  document.addEventListener('shopify:section:load',function(e){$$('[data-pdp]',e.target).forEach(initPdp)});
})();
